import { createSelector } from "reselect";

//const selectStringSource = state => state.entities.string_resource;
const selectEntityData = state =>
  state.entities.translation ? state.entities.translation.data : {};

export const makeSelectTranslation = () =>
  createSelector([selectEntityData], substate => substate);
